module.exports = __webpack_public_path__ + "static/media/multi-1.e044705e.png";